export default (type, colors) => {
  const styles = {
    default: {
      'showcase-grid__image--welcome': {
        backgroundImage: "url('images/pncc-logo-bg.jpg')"
      },
      'showcase-grid__link': {
        customCSS: `
          .showcase-grid__link:before {
            color: ${colors.primary};
          }
        `
      }
    },
    type1: {
      'showcase-grid__image': {
        minHeight: '400px',
        customCSS: `
          .showcase-grid__image:before {
            content: '';
            width: 100%;
            height: 40%;
            max-height: 190px;
            position: absolute;
            bottom: 0;
            left: 0;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) -5.98%, #000 68.2%);
            opacity: 0.5;
          }
        `
      },
      'showcase-grid__image--welcome': {
        background: colors.secondary,
        customCSS: `
        .showcase-grid__image:before {
          display: none;
        }
        `
      },
      'showcase-grid__flag': {
        paddingLeft: '60px',
        width: '100%',
        minHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        left: 0,
        right: 0,
        top: 'auto',
        bottom: '1rem',
        maxWidth: 'calc(100% - 2rem)',
        margin: '0 1rem',
        zIndex: '999',
        customCSS: `
          .showcase-grid__flag:before {
            display: none;
          }
        `
      },
      'showcase-grid__flag__inner': {
        top: 0,
        left: 0,
        bottom: 0,
        width: '100%',
        maxWidth: '100%',
        paddingLeft: '60px',
        customCSS: `
          .showcase-grid__flag__inner:before {
            display: none;
          }
        `
      },
      'showcase-grid__flag__content': {
        height: '100%',
        display: 'flex',
        marginLeft: '15px',
        flexDirection: 'column',
        justifyContent: 'center'
      },
      'showcase-grid__icon': {
        background: 'transparent',
        borderRadius: 'inherit',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        top: 0,
        width: '60px',
        height: '60px',
        fontSize: '20px',
        customCSS: `
          .showcase-grid__flag .icon:after {
            content: "\\E902";
            width: 60px;
            height: 60px;
            display: block;
            font-size: 60px;
            font-family: 'moon-iconfont';
            position: absolute;
            left: 0;
            top: 0;
            line-height: normal;
            z-index: 1;
            color: ${colors.light};
          }
          .showcase-grid__flag .icon:before {
            z-index: 9;
            position: relative;
          }
        `
      },
      'showcase-grid__item--hero__flag': {
        maxWidth: 'none',
        paddingRight: 0,
        padding: '10px',
        left: 0,
        top: 0,
      },
      'showcase-grid__flag__h2': {
        color: '#fff',
        fontWeight: 'bold'
      },
      'showcase-grid__item--any': {
        width: '100%',
        customCSS: `
          @media screen and (min-width: 32em) {
            .showcase-grid__item--bottom_left {
              width: 100%;
            }
            .showcase-grid {
              height: calc(100vh - 200px);
            }
          }
          @media screen and (min-width: 48em) {
            .showcase-grid__item--bottom_left,
            .showcase-grid__item--left {
              width: 40%;
            }
          };
        `
      },
      'showcase-grid__link': {
        customCSS: `
          .showcase-grid__link:before {
            color: ${colors.primary};
          }
        `
      },
      'showcase-grid--wideflags': {
        marginTop: '20px'
      },
      'flag__bg': {
        width: '100%',
        height: '40%',
        maxHeight: '190px',
        position: 'absolute',
        bottom: 0,
        left: 0,
        background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) -5.98%, #000 68.2%)',
        opacity: '0.5',
        zIndex: '99'
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/showcaseGrid.js